import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';
import { CompanyPromotionItemProps } from '@components/ui/listing/PromotionGroup/CompanyPromotionGroupInterface';

const DesktopPromotions = dynamic(() => import('./DesktopPromotions'), {
  ssr: true,
});

const MobilePromotions = dynamic(() => import('./MobilePromotions'), {
  ssr: true,
});
const Promotions = ({
  itemPromotions,
}: {
  itemPromotions: CompanyPromotionItemProps[];
}) => {
  const { isDesktop } = useDevice();
  return isDesktop ? (
    <DesktopPromotions itemPromotions={itemPromotions} />
  ) : (
    <MobilePromotions itemPromotions={itemPromotions} />
  );
};

export default Promotions;
